import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './modules/auth/helpers/authguard';
import { PatientLoginComponent } from './modules/auth/patientLogin/patientLogin.component';
import { LoginPageComponent } from './modules/auth/login-page/login-page.component';
import { BlankWorkSpaceComponent } from './modules/blank-work-space/blank-work-space.component';
import { TokenHandlerComponent } from './token.ignore/token-handler/token-handler.component';
import { CheckInComponent } from './modules/check-in/check-in.component';
import { LandingComponent } from './landing/landing.component';
import { PerioComponent } from './modules/perio/perio.component';
import {SchedulerComponent} from './main-interface/scheduler/scheduler.component';
import {ImageCollageComponent} from './modules/imaging/image-collage/image-collage.component';
import {ConfigurationComponent} from './modules/configuration/configuration.component';
import {TdoImagingComponent} from './main-interface/imaging/tdo-imaging.component';
import {TdoNotesExpandedComponent} from './main-interface/controls/tdo-notes/tdo-notes-expanded/tdo-notes-expanded.component';
import {RoleGuard} from './modules/auth/helpers/role-guard';
import {AccessDeniedComponent} from './modules/auth/access-denied/access-denied.component';
import {PaymentProcessorConfigurationComponent} from './modules/configuration/payment-processor-configuration/payment-processor-configuration.component';
import {ReportViewerDialogComponent} from './modules/reports/report-viewer-dialog/report-viewer-dialog.component';
import {
  CheckoutProcessorConfigurationComponent
} from './modules/configuration/checkout-processor-configuration/checkout-processor-configuration.component';
import { FormViewerComponent } from './modules/forms/form-viewer/form-viewer.component';
import {PatientAutoLoginComponent} from './modules/auth/patient-auto-login/patient-auto-login-component';
import {ReferrerAutoLoginComponent} from './modules/auth/referrer-auto-login/referrer-auto-login-component';
import {OfficeAutoLoginComponent} from './modules/auth/office-auto-login/office-auto-login-component';
import {PatientAuthGuard} from './modules/auth/helpers/patientAuthguard';
import {PaymentMethodConfigurationComponent} from './modules/configuration/payment-method-configuration/payment-method-configuration.component';
import { CommonModule } from '@angular/common';
import {ReferralPortalComponent} from "./modules/referral-manager/referral-portal/referral-portal.component";
import { ReferrerLoginComponent } from './modules/auth/referrerPortal/referrer-login.component';
import { ReferrerAuthGuard } from './modules/auth/helpers/referrerAuthguard';
import {TdoSchedulerComponent} from "./modules/scheduler/tdo-scheduler/tdo-scheduler.component";
import { ArCardPaymentReceiptComponent } from './modules/ar/payment/ar-card-payment-receipt/ar-card-payment-receipt.component';
import { SelectivePreloadingStrategy } from './routing/selective-preloading.strategy';


const routes: Routes = [  
  {
    path: 'access-denied',
    component: AccessDeniedComponent
  },
  {
    path: 'handleToken',
    canActivate: [AuthGuard, RoleGuard],
    component: TokenHandlerComponent,
  },
  {
    path: 'insurance', loadChildren: () => import('./modules/insurance/insurance.module').then(m => m.InsuranceModule),
    canActivate: [AuthGuard, RoleGuard],
  },
  // {
  //  path: 'perio',
  //  canActivate: [AuthGuard],
  //  data: {roles: 'View Perio'},
  //  loadChildren: () => import('./modules/perio-chart/perio-chart.module').then(m => m.PerioChartModule)
  // },
  {
    path: 'perio',
    canActivate: [AuthGuard, RoleGuard],
    data: { roles: 'View Perio' },
    component: PerioComponent,
  },
  {
    path: 'landing',
    component: LandingComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'checkin',
    component: CheckInComponent,
    canActivate: [AuthGuard, RoleGuard],
  },
  {
    path: 'patientportal',
    loadChildren: () => import('./modules/patient-portal/patient-portal.module').then(m => m.PatientPortalModule),
    canActivate: [PatientAuthGuard, RoleGuard],
    data: { roles: 'Is Patient' }
  },
  {
    path: 'referrerportal',
    loadChildren: () => import('./modules/referrer-portal/referrer-portal.module').then(m => m.ReferrerPortalModule),
    canActivate: [ReferrerAuthGuard, RoleGuard],
    data: { roles: 'Is Referrer' }
  },
  {
    path: 'pay',
    loadChildren: () => import('./modules/payment-portal/payment-portal.module').then(m => m.PaymentPortalModule),
  },
  {
    path: 'pl/:t',
    component: PatientAutoLoginComponent
  },
  {
    // CL-618/CL-621 follow-up: referring-doctor magic link, mirroring 'pl/:t' above - see
    // ReferrerAutoLoginComponent.
    path: 'rl/:t',
    component: ReferrerAutoLoginComponent
  },
  {
    path: 'ol/:t',
    component: OfficeAutoLoginComponent
  },
  {
    path: 'patientformviewer/:formId',
    component: FormViewerComponent,
    canActivate: [PatientAuthGuard],
  },
  {
    path: 'scheduler',
    component: SchedulerComponent,
    canActivate: [AuthGuard, RoleGuard],
  },
  {
    path: 'tdo-scheduler',
    component: TdoSchedulerComponent,
    canActivate: [AuthGuard, RoleGuard],
  },
  {
    path: 'patient', loadChildren: () => import('./modules/patient/patient.module').then(m => m.PatientModule),
    canActivate: [AuthGuard, RoleGuard],
    data: { roles: 'View Patient' }
  },
  {
    path: 'forms', loadChildren: () => import('./modules/forms/froms.module').then(m => m.FormsTDOModule),
    canActivate: [AuthGuard, RoleGuard],
    data: { roles: 'View Forms' }
  },
  {
    path: 'patientLogin',
    component: PatientLoginComponent,
  },
  {
    path: 'referrerLogin',
    component: ReferrerLoginComponent,
  },
  {
    path: 'login',
    component: LoginPageComponent
  },
  {
    path: 'studio',
    component: TdoImagingComponent,
    canActivate: [AuthGuard, RoleGuard],
  },
  {
    path: 'reports',
    component: ReportViewerDialogComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'referralPortal',
    component: ReferralPortalComponent
 },
  {
    path: 'collage',
    component: ImageCollageComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'homepage',
    component: LandingComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'fee-schedule',
    loadChildren: () => import('./modules/fee-schedule/fee-schedule.module').then(m => m.FeeScheduleModule),
    data: { preload: true },
    canActivate: [AuthGuard],
  },
  {
    path: 'procedure',
    loadChildren: () => import('./modules/procedure/procedure.module').then(m => m.ProcedureModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'configuration',
    loadChildren: () => import('./modules/configuration/configuration.module').then(m => m.ConfigurationModule),
    component: ConfigurationComponent,
    canActivate: [AuthGuard, RoleGuard],
  },
  {
    path: 'ar',
    loadChildren: () => import('./modules/ar/ar.module').then(m => m.ARModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'reports',
    loadChildren: () => import('./modules/reports/reports.module').then(m => m.ReportsModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'notes',
    component: TdoNotesExpandedComponent,
    canActivate: [AuthGuard, RoleGuard],
  },
  { path: 'payment-processor-configuration',
    component: PaymentProcessorConfigurationComponent,
  },
  { path: 'checkout-processor-configuration',
    component: CheckoutProcessorConfigurationComponent,
  },
  { path: 'payment-method-configuration',
    component: PaymentMethodConfigurationComponent,
  },
  {
    path: 'payment-receipt/:paymentId',
    component: ArCardPaymentReceiptComponent,
    canActivate: [AuthGuard],
  },
  {
    path: '',
    component: BlankWorkSpaceComponent,
    canActivate: [AuthGuard, RoleGuard],
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: SelectivePreloadingStrategy }),
  CommonModule],
  exports: [RouterModule]
})
export class AppRoutingModule { }
